module.exports = __webpack_public_path__ + "contactIco.webp?aa905f3b94b586ec877658ae90323855";